export default {
  title: 'Gestión de Capas',
  name: 'Nombre',
  actions: 'Acciones:',
  cancel: 'Cancelar',
  accept: 'Aceptar',
  activate: 'Activar capa',
  deactivate: 'Desactivar capa',
  sourceInfo: 'Información de la fuente',
  source: 'Fuente',
  layer: 'Capa',
  theme: 'Temática',
  opacityLevel: 'Opacidad: {percentage}%',
  currentOpacity: 'Opacidad: {percentage}%'
}
